<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/index/product-1.jpg" alt=""></img>
            </div>
            <div class="detail-banner-r">
                <div class="detail-banner-t1">
                    动力系统
                </div>
                <div class="detail-banner-t2">
                    4D24 柴油机
                </div>
                <div class="detail-banner-desc">
                    这是一段对产品的简介，如适用于雪场等明亮环境下的xxx使用，针对xxxx板上的关键元器件(电容、电感、连接器等)的XY位置、Z向高度以及xxxxxx脚高度等尺寸的量测。
                </div>
                <div class="detail-banner-btn">
                    <div>
                        联系我们
                    </div>
                    <img src="/assets/index/right.png" alt="">
                </div>
            </div>
        </div>

        <!-- 四个模块分开的 -->
        <div class="detail-box">
            <div class="detail-title">
                强动力
            </div>
            <div class="detail-utils">
                <div class="detail-utils-item">
                    <div class="detail-utils-d">
                        大功率
                    </div>
                    <div class="detail-utils-u">
                        135kW/3600rpm
                    </div>
                </div>
                <div class="detail-utils-item">
                    <div class="detail-utils-d">
                        最大扭矩
                    </div>
                    <div class="detail-utils-u">
                        480N·m/1500~2500rpm
                    </div>
                </div>
                <div class="detail-utils-item">
                    <div class="detail-utils-d">
                        低速扭矩
                    </div>
                    <div class="detail-utils-u">
                        260N·m/1000 rpm、350 N·m/1200 rpm
                    </div>
                </div>
            </div>

            <div class="detail-four-list">
                <div class="detail-four-item">
                    <div class="img-box">
                        <img src="/assets/index/product-1.jpg" alt=""></img>
                    </div>
                </div>
                <div class="detail-four-item">
                    <div class="detail-four-title">
                        高效VGT增压器
                    </div>
                    <div class="detail-four-desc">
                        增压器采用电控执行器改变涡轮流通截面通过CFD流场仿真分析，实现各转速工况下的极佳匹配，发动机性能更胜一筹，瞬态响应性更好，充气效率提升20%，低速动力性提升30%，1000rpm时扭矩即达到260N-m。
                    </div>
                    <div class="detail-four-units">
                        <div class="detail-four-unit-item">
                            <div class="detail-four-u">
                                260
                                <span>
                                    N-m
                                </span>
                            </div>
                            <div class="detail-four-d">
                                1000rpm时扭矩即达到
                            </div>
                        </div>
                        <div class="detail-four-unit-item">
                            <div class="detail-four-u">
                                20
                                <span>
                                    %
                                </span>
                            </div>
                            <div class="detail-four-d">
                                充气效率提升
                            </div>
                        </div>
                        <div class="detail-four-unit-item">
                            <div class="detail-four-u">
                                20
                                <span>
                                    %
                                </span>
                            </div>
                            <div class="detail-four-d">
                                低速动力性提升
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-four-item">
                    <div class="detail-four-title">
                        高效VGT增压器
                    </div>
                    <div class="detail-four-desc">
                        增压器采用电控执行器改变涡轮流通截面通过CFD流场仿真分析，实现各转速工况下的极佳匹配，发动机性能更胜一筹，瞬态响应性更好，充气效率提升20%，低速动力性提升30%，1000rpm时扭矩即达到260N-m。
                    </div>
                    <div class="detail-four-units">
                        <div class="detail-four-unit-item">
                            <div class="detail-four-u">
                                63
                                <span>
                                    %
                                </span>
                            </div>
                            <div class="detail-four-d">
                                涡流比提升
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-four-item">
                    <div class="img-box">
                        <img src="/assets/index/product-1.jpg" alt=""></img>
                    </div>
                </div>
            </div>
        </div>

        <!-- 左右两个上下结构 -->
        <div class="detail-box">
            <div class="detail-title">
                低油耗
            </div>
            <div class="detail-desc">
                200 g/kW.h燃油消耗率，创造省油新高度
            </div>
            <div class="detail-updown-list">
                <div class="detail-updown-item">
                    <div class="detail-updown-title">
                        高、低压EGR系统
                    </div>
                    <div class="detail-updown-desc">
                        通过高、低压EGR在不同工况下的配合使用，大幅提升EGR率，减少泵气损失，通过EGR率的精准控制来降低NOx排放油耗降低3%，从而应对日益严苛的排放法规要求。
                    </div>
                    <div class="img-box">
                        <img src="/assets/index/product-1.jpg" alt=""></img>
                    </div>
                </div>
                <div class="detail-updown-item">
                    <div class="detail-updown-title">
                        高、低压EGR系统
                    </div>
                    <div class="detail-updown-desc">
                        通过高、低压EGR在不同工况下的配合使用，大幅提升EGR率，减少泵气损失，通过EGR率的精准控制来降低NOx排放油耗降低3%，从而应对日益严苛的排放法规要求。
                    </div>
                    <div class="img-box">
                        <img src="/assets/index/product-1.jpg" alt=""></img>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail-swiper-list detail-box">
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        低油耗
                    </div>
                    <div class="detail-desc">
                        200 g/kW.h燃油消耗率，创造省油新高度
                    </div>
                </div>
                <div class="detail-tabs">
                    <div class="detail-tab-item active">
                        <div class="detail-tab-title">
                            低油耗
                        </div>
                        <div class="detail-tab-desc">
                            200 g/kW.h燃油消耗率，创造省油新高度
                        </div>
                    </div>
                    <div class="detail-tab-item">
                        <div class="detail-tab-title">
                            低油耗
                        </div>
                        <div class="detail-tab-desc">
                            200 g/kW.h燃油消耗率，创造省油新高度
                        </div>
                    </div>

                </div>
                <div class="detail-swiper-utils">
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            0.8%
                        </div>
                        <div class="detail-swiper-d">
                            油耗降低
                        </div>
                    </div>
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            0.8%
                        </div>
                        <div class="detail-swiper-d">
                            油耗降低
                        </div>
                    </div>
                </div>
            </div>

            <div class="detail-swiper-right swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide img-box">
                        <img src="/assets/index/product-1.jpg" alt=""></img>
                    </div>
                    <div class="swiper-slide img-box">
                        <img src="/assets/index/product-2.jpg" alt=""></img>
                    </div>
                </div>
            </div>
        </div>


        <!-- 多文案，单个或多个图 -->
        <div class="detail-swiper-list detail-box">
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        低油耗
                    </div>
                    <div class="detail-desc">
                        200 g/kW.h燃油消耗率，创造省油新高度
                    </div>
                </div>
                <div class="detail-tabs">
                    <div class="detail-tab-item active">
                        <div class="detail-tab-title">
                            低油耗
                        </div>
                        <div class="detail-tab-desc">
                            200 g/kW.h燃油消耗率，创造省油新高度
                        </div>
                    </div>
                    <div class="detail-tab-item">
                        <div class="detail-tab-title">
                            低油耗
                        </div>
                        <div class="detail-tab-desc">
                            200 g/kW.h燃油消耗率，创造省油新高度
                        </div>
                    </div>

                </div>
                <div class="detail-swiper-utils">
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            0.8%
                        </div>
                        <div class="detail-swiper-d">
                            油耗降低
                        </div>
                    </div>
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            0.8%
                        </div>
                        <div class="detail-swiper-d">
                            油耗降低
                        </div>
                    </div>
                </div>
            </div>

            <div class="detail-swiper-right swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide img-box">
                        <img src="/assets/index/product-1.jpg" alt=""></img>
                    </div>
                    <div class="swiper-slide img-box">
                        <img src="/assets/index/product-2.jpg" alt=""></img>
                    </div>
                </div>
            </div>
        </div>
       

        <!-- 单图片单数 -->
        <div class="detail-swiper-list detail-box">
             <div class="img-box detail-swiper-right ">
                <img src="/assets/index/product-1.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        低油耗
                    </div>
                    <div class="detail-desc">
                        200 g/kW.h燃油消耗率，创造省油新高度
                    </div>
                </div>
                <div class="detail-swiper-utils">
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            0.8%
                        </div>
                        <div class="detail-swiper-d">
                            油耗降低
                        </div>
                    </div>
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            0.8%
                        </div>
                        <div class="detail-swiper-d">
                            油耗降低
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-bottom">
            <div class="detail-bottom-title">
                您可能还对以下设备感兴趣
            </div>
            <div class="detail-bottom-list">
                <div class="detail-bottom-item" v-for="(item, index) in dataList" :key="index">
                    <div class="detail-bottom-left">
                        <div class="detail-bottom-t">
                            {{ item.title }}
                        </div>
                        <div class="detail-bottom-d">
                            {{ item.descss }}
                        </div>
                        <a :href="item.link" class="detail-bottom-btn">
                            <span>
                                了解更多
                            </span>
                            <img src="/assets/index/arrow-right.png" alt=""></img>
                        </a>
                    </div>
                    <div class="detail-bottom-img img-box">
                        <img :src="item.imgs" alt=""></img>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const swiperInstances = ref({});
const dataList = ref([
    {
        title: '产品1',
        descss: "描述",
        imgs: '/assets/index/product-1.jpg',
        link: '/product-details',
    },
    {
        title: '产品2',
        descss: "描述",
        imgs: '/assets/index/product-1.jpg',
        link: '/product-details',
    }
])


onMounted(() => {
    nextTick(() => {
        const swiperContainers = document.querySelectorAll('.swiper-container');

        swiperContainers.forEach((container, index) => {
            const containerKey = `swiper_${index}`;
            container.dataset.swiperKey = containerKey;
            const swiperInstance = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 300,
                preventClicks: true,
                effect: 'fade',
            });
            swiperInstances.value[containerKey] = swiperInstance;
        });

        bindTabClickEvent();
    });
});
function bindTabClickEvent() {
    const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

    allSwiperLists.forEach((swiperList) => {
        const tabItems = swiperList.querySelectorAll('.detail-tab-item');
        const targetSwiperContainer = swiperList.querySelector('.swiper-container');

        if (!tabItems.length || !targetSwiperContainer) return;

        const containerKey = targetSwiperContainer.dataset.swiperKey;
        const targetSwiper = swiperInstances.value[containerKey];
        if (!targetSwiper) return;

        const handleTabAction = (tabItem, localTabIndex) => {
            tabItems.forEach(item => item.classList.remove('active'));
            tabItem.classList.add('active');
            targetSwiper.slideTo(localTabIndex, 300, true);
        };
        tabItems.forEach((tabItem, localTabIndex) => {
            const handleTabClickWrapper = () => {
                handleTabAction(tabItem, localTabIndex);
            };
            tabItem.removeEventListener('click', handleTabClickWrapper);
            tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
            tabItem.addEventListener('click', handleTabClickWrapper);
            tabItem.addEventListener('mouseenter', handleTabClickWrapper);
        });
    });
}

</script>

<script>
export const pageConfig = {
    title: '详情页模板2',
    keywords: '',
    description: '',
    outputPath: 'engine/product-details.html'
};

import { createApp } from 'vue';
import App from './product-details.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./product-details.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>